import FailureModeWiseRejection from "./FailureModeWiseRejection";

export default FailureModeWiseRejection;
